import { render, staticRenderFns } from "./ProjectAddVersionModal.vue?vue&type=template&id=50f40693&"
import script from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddVersionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports